<template>
  <div class="container homepage flex">
    <div class="bg-img">
      <div class="cloud">
        <img src="../assets/images/cloud.png" alt="bg-img" />
      </div>
      <div class="cross">
        <img src="../assets/images/cross.png" alt="bg-img" />
      </div>
      <div class="curveline">
        <img src="../assets/images/curveline.png" alt="bg-img" />
      </div>
      <div class="butterfly">
        <img src="../assets/images/butterfly.png" alt="bg-img" />
      </div>
      <div class="scale">
        <img src="../assets/images/scale.png" alt="bg-img" />
      </div>
      <div class="rainbow">
        <img src="../assets/images/rainbow.png" alt="bg-img" />
      </div>
    </div>
    <div class="form-container flex">
      <div class="logo">
        <img src="../assets/images/UP_SKOOL_LOGO.png" alt="" />
      </div>
      <div class="text-container">
        <h1>Sign In</h1>
        <p>Up-skool sign in</p>
      </div>
      <div class="inputs-container flex">
        <div class="input-container">
          <span class="icon"
            ><img src="../assets/images/smartphone.png" alt=""
          /></span>
          <input
            v-model="mobile"
            type="text"
            name="mobile"
            id="mobile"
            maxlength="10"
            placeholder="E.g. 9999999999"
          />
        </div>
        <div v-if="screenType == 'O'" class="input-container">
          <span class="icon"
            ><img src="../assets/images/pin.png" alt=""
          /></span>
          <input
            v-model="otp"
            type="text"
            name="otp"
            id="otp"
            placeholder="E.g. 123456"
          />
          <div class="eye icon is-right has-text-link">
            <img
              :src="require('@/assets/images/ant-design_eye-filled.png')"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="forgetpass flex">
        <div class="forget-pass">
          Forgot password?
        </div>
      </div>
      <div class="button-container flex">
        <!-- <div class="button outline flex">
                  <p>Login with google</p>
                  <span class="icon"><img src="../assets/images/google-icon.svg" alt=""></span>
              </div> -->
        <div class="button flex" @click="handler()">{{ screenType === "L" ? "Login" : "Verify OTP"}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations } from "vuex";
export default {
  name: "login",
  components: {},
  data() {
    return {
      isLoading: false,
      mobile: "",
      otp: "",
      screenType: "L", // L - Login, O - Otp
    };
  },
  methods: {
    ...mapActions(["loginUser", "requestUserOtp"]),
    ...mapMutations(["SET_TEACHER_PROFILE"]),
    handler(){
      if(this.screenType === "L"){
        this.requestLogin()
      }else if(this.screenType === "O"){
        this.login()
      }
    },
    requestLogin() {
      this.requestUserOtp({ mobile: this.mobile })
        .then((res) => {
          this.screenType = "O";
          this.$buefy.toast.open({
            message: res.data.msg,
            type: "is-success",
          });
        })
        .catch((err) => {
          this.isLoading = false;
          this.$buefy.toast.open({
            message: err.response.data.msg,
            type: "is-danger",
          });
        });
    },
    login() {
      this.isLoading = true;
      // If OTP is generated then allow user to ent
      this.loginUser({
        mobile: this.mobile,
        otp : this.otp
      }).then(() => {
        this.isLoading = false;
        this.$router.push({
          name: "home",
        });
      }).catch((err) => {
          this.isLoading = false;
          this.$buefy.toast.open({
            message: err.response.data.msg,
            type: "is-danger",
          });
        });
    },
    isJsonString(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
  },
  created() {
    let search = new URLSearchParams(window.location.search);
    const tokenEncoded = search.get("token");
    if (tokenEncoded) {
      const tokenDecoded = window.atob(tokenEncoded);
      if (this.isJsonString(tokenDecoded)) {
        const data = JSON.parse(tokenDecoded);
        
        this.SET_TEACHER_PROFILE(data);
        console.log(data);
        this.$router.push({
          name: "home",
        });
      }
    }
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.container {
  position: relative;
}

.bg-img {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.bg-img div {
  display: flex;
  position: absolute;
  width: auto;
}

.title {
  font-size: 3vw;
  margin: 0 !important;
}

img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.button {
  flex-direction: row;
  padding: 1vw 1.25vw;
  width: 100%;
  background: #8919e7;
  border-radius: 1vw;
  color: #fff;
  gap: 1vw;
  cursor: pointer;
  position: relative;
  text-transform: capitalize;
}
.button.outline {
  border: 0.063rem solid #8919e7;
  background: #fff;
  color: #000;
}
.link {
  cursor: pointer;
}

.main {
  align-items: center;
  margin: 0vw 0vw;
  position: relative;
}
/* responsive page*/

/* tablet */
@media screen and (max-width: 1023px) {
  .title {
    font-size: 3.5vw !important;
  }
}

/* Mobiles */
@media screen and (max-width: 767px) {
  .title {
    font-size: 4vw !important;
  }
}

@media screen and (max-width: 467px) {
  .title {
    font-size: 5vw !important;
  }
}
.bg-img .cloud {
  top: 0;
  right: 6.6%;
  left: 70.4%;
}
.bg-img .cross {
  top: 32.5%;
  right: 7.375%;
  left: 86.5%;
}
.bg-img .curveline {
  top: 17%;
  left: 63.5%;
  right: 26.6%;
}
.bg-img .butterfly {
  left: 84.75%;
  right: 0;
  bottom: 0;
}
.bg-img .scale {
  right: 8.86%;
  left: 77.25%;
  top: 50%;
}
.homepage {
  min-height: 100vh;
  width: 100%;
  padding: 1rem;
}

.form-container {
  padding: 2rem;
  gap: 0.63rem;
  width: 100%;
  max-width: 482px;
  position: relative;
  margin: auto;
  top: 15%;
}

.logo {
  width: 35%;
}

.text-container {
  margin-top: 5.2%;
}
.text-container h1 {
  font-style: normal;
  font-weight: 700;
  font-size: 2.25rem;
  text-align: center;
  color: #000000;
}
.text-container p {
  font-weight: 400;
  font-size: 1rem;
  text-align: center;
  color: #595959;
}
.inputs-container {
  gap: 1.4375rem;
  margin: 4% 0 2.2%;
  width: 100%;
  position: relative;
}
.input-container {
  border: 1px solid #c2c2c2;
  border-radius: 1rem;
  padding: 4.1% 4%;
  width: 100%;
  position: relative;
  background: #fff;
  display: flex;
  align-items: center;
  gap: 4%;
}
.input-container input {
  all: unset;
  flex: 1;
  width: 100%;
}
.icon {
  width: 1.438rem;
  height: 1.438rem;
}
.forgetpass {
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}
.rem-me {
  flex-direction: row;
  gap: 0.625rem;
}
.rem-me input[type="checkbox"] {
  all: unset;
  border: 1px solid currentColor;
  width: 20px;
  height: 20px;
  display: grid;
  place-content: center;
  border-radius: 5px;
  overflow: hidden;
}
.rem-me input[type="checkbox"]:before {
  content: "\2713";
  transform: scale(0);
  font-size: 25px;
  color: #fff;
  background: #29b6f6;
}
.rem-me input[type="checkbox"]:checked::before {
  transform: scale(1);
}
.button-container {
  width: 100%;
  gap: 0.8125rem;
  margin-top: 2.5rem;
}
.button-container .button .icon {
  position: static;
}
.eye {
  width: 27.25px !important;
  height: 100% !important;
  right: 7.42% !important;
}
</style>
